/**
 * Converts decimal number below 1 into a usable percentage between 0 and 99
 */
export const roundDecimalToPercentage = (input: number) => Math.round(input * 100);
